import { useSelector } from 'react-redux';

export const useIsReadonly = () => {
    const isReadonly = useSelector(state => state.session.user.readonly);

    return [isReadonly];
};